// extracted by mini-css-extract-plugin
export default {"title":"Form_title__SiIhw","secondary":"Form_secondary__QiNh0","password":"Form_password__8ah-B","btn":"Form_btn__TTwyw","email":"Form_email__6Qw9c","logo":"Form_logo__TScXW"};